import { render, staticRenderFns } from "./cultivate.vue?vue&type=template&id=713db8c7&scoped=true&"
import script from "./cultivate.vue?vue&type=script&lang=js&"
export * from "./cultivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713db8c7",
  null
  
)

export default component.exports